import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
//import { Link } from "react-router-dom";
import Layout from "../../components/common/Layout";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
//import Select from "react-select";
import Alerts from "../layout/Alerts";
import AlertContext from "../../context/alert/alertContext";
import checkTime from "../../components/constants/CheckTime"

const Role = props => {
    const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 13)[0];
    const alertContext = useContext(AlertContext);
    const { setAlert } = alertContext;
    const [roleSearchFormData, setRoleSearchFormData] = useState({ name: ""});
    const [roleData, setRoleData] = useState([]);
    const userId =
        JSON.parse(localStorage.getItem("user")) === null
        ? null
        : JSON.parse(localStorage.getItem("user"))[0].Id;
    const roleColumns = [
        {
            cell: row => (
              <div>
                <button
                    hidden={!pagePermission.IsUpdate}
                  className="btn btn-sm btn-primary ml-2"
                  type="button"
                  onClick={() => {
                    setShowEditModal({ show: "Edit", pop: true, Id: row.Id  })
                  }}
                >
                  <i className="fa fa-pencil"></i> Edit
                </button>
                <button
                    hidden={!pagePermission.IsDelete}
                  className={"btn btn-sm btn-" + ( row.cantDelete ? "secondary" : "danger") + " ml-2"}
                  type="button"
                  disabled={row.cantDelete}
                  onClick={() => {
                    setShowDeleteModel({ Id: row.Id, pop: true })
                  }}
                >
                  <i className="fa fa-remove"></i> Delete
                </button>
              </div>
            ),
            ignoreRowClick: false,
            allowOverflow: true,
            width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "180px" : "0px",
            button: true
        },
        {
            name: "Role Name",
            selector: "RoleName",
            sortable: true,
            wrap: true
        },
        {
            name: "Status",
            selector: "StatusActive",
            sortable: true,
            center: true,
            cell: row => (
              <div>
                { !row.StatusActive && (
                  <h6>
                    <span className="badge badge-danger text-left">InActive</span>
                  </h6>
                )}
                { row.StatusActive && (
                  <h6>
                    <span className="badge badge-success text-left">Active</span>
                  </h6>
                )}
              </div>
            )
        },
        {
            name: "Remark",
            selector: "Remark",
            sortable: true,
            wrap: true
        },
        {
            name: "LastUpdateBy",
            selector: "LastUpdateBy",
            sortable: true,
            wrap: true
        },
        {
            name: "LastUpdateDateTime",
            selector: "LastUpdateDateTime",
            sortable: true,
            wrap: true
        },
        {
            name: "CreateBy",
            selector: "CreateBy",
            sortable: true,
            wrap: true
        },
        {
            name: "CreateDateTime",
            selector: "CreateDateTime",
            sortable: true,
            wrap: true
        }
    ];
    const defaultModal = { show: "", pop: false, Id: ""  };
    const [showEditModal, setShowEditModal] = useState(defaultModal);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showDeleteModal, setShowDeleteModel] = useState({ Id: "", pop: false });
    const roleSearchUpdate = () => {
        axios
        .get(process.env.REACT_APP_API_URL + "/api/role", {
            params: roleSearchFormData
        })
        .then(res => {
            setRoleData(res.data);
        });
    }
    const [roleSettingFormData, setRoleSettingFormData] = useState([]);
    const [roleNameFormData, setRoleNameFormData] = useState({ name:'', desc: ''});
    const selectDefault = { view: false, create: false, update: false, delete: false };
    const [selectAll, setSelectAll] = useState(selectDefault);

    useEffect(() => {
        checkTime();
        document.addEventListener("mousedown",  (e) => { checkTime(); });
        roleSearchUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    useEffect(() => {
        if(showEditModal.pop){
            axios
            .get(process.env.REACT_APP_API_URL + "/api/rolepermission/" + showEditModal.Id )
            .then(res => {
                setRoleSettingFormData( res.data );
                if(showEditModal.show === 'Edit'){ 
                    setRoleNameFormData({ name:res.data[0].RoleName, desc: res.data[0].Remark});
                }
            })
        }else{
            setRoleSettingFormData([]);
            setRoleNameFormData({ name:'', desc: ''});
            setSelectAll(selectDefault);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[showEditModal.pop])
    useEffect(() => {
        if(selectAll.view){
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsView: true}) ))
        } else{
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsView: false})))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectAll.view])
    useEffect(() => {
        if(selectAll.create){
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsCreate: true}) ))
        } else{
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsCreate: false})))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectAll.create])
    useEffect(() => {
        if(selectAll.update){
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsUpdate: true}) ))
        } else{
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsUpdate: false})))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectAll.update])
    useEffect(() => {
        if(selectAll.delete){
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsDelete: true}) ))
        } else{
            setRoleSettingFormData(roleSettingFormData.map( e => ({ ...e, IsDelete: false})))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectAll.delete])

    const saveAddEditRole = (action) => {
        if (action === "Add") {
            axios
            .post(
                process.env.REACT_APP_API_URL +
                "/api/rolepermission/" ,
                { ...roleNameFormData, 
                    setting: roleSettingFormData.filter(x => x.ParentId !== null),
                    createBy: userId
                }
            )
            .then(res => {submitSave(res); }
            );
        } else if (action === "Edit") {
            axios
            .put(
                process.env.REACT_APP_API_URL +
                "/api/rolepermission/" + showEditModal.Id ,
                { ...roleNameFormData, 
                    setting: roleSettingFormData.filter(x => x.ParentId !== null),
                    createBy: userId
                }
            )
            .then(res => {submitSave(res); }
            );
        }
        const submitSave = res => {
            setShowConfirm(false);
            if (res.data.status === "0") {
                setAlert(res.data.msg, "success");
                roleSearchUpdate();
                setShowEditModal(defaultModal);
            } else {
                setAlert(res.data.msg, "danger");
                //setShowEditModal(defaultModal);
            }
        }
        
    }

    const genBodyTableSetting = (data) => {
        if(data.ParentId === null){
            return  (<tr key={data.RowID} >
                        <th scope="row" colSpan="5" style={{textAlign:"start", backgroundColor:"whitesmoke" }}>
                            <i className={"fa fa-" + data.Icon}></i> {data.Label}
                        </th>
                    </tr>)
        }else {
            let IsView = (roleSettingFormData[data.RowID-1].IsView || false);
            let IsCreate = (roleSettingFormData[data.RowID-1].IsCreate || false);
            let IsUpdate = (roleSettingFormData[data.RowID-1].IsUpdate || false);
            let IsDelete = (roleSettingFormData[data.RowID-1].IsDelete || false);
            return  (<tr key={data.RowID} >
                        <th scope="row" style={{textAlign:"start"}}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <i className={"fa fa-" + data.Icon}></i> {data.Label}
                        </th>
                        <td>
                            <label className="switch" 
                                style={ IsView? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }
                            >
                                <input 
                                    type="checkbox" 
                                    checked={IsView}
                                    onChange={() => 
                                        setRoleSettingFormData(
                                            [
                                                ...roleSettingFormData.slice(0, data.RowID-1), 
                                                { ...roleSettingFormData[data.RowID-1], IsView: !IsView },
                                                ...roleSettingFormData.slice(data.RowID), 
                                            ]
                                        ) 
                                    } 
                                />
                                <span className="slider round" style={{padding:"0 10px"}}>{IsView? 'on' : 'off'}</span>
                            </label>
                        </td>
                        <td>
                            <label className="switch"
                                style={
                                    IsCreate? 
                                    {color:"aliceblue", textAlign:"start"} 
                                    :{color:"dimgray", textAlign:"end"}
                                }
                            >
                                <input 
                                    type="checkbox" 
                                    checked={IsCreate}
                                    onChange={() => 
                                        setRoleSettingFormData(
                                            [
                                                ...roleSettingFormData.slice(0, data.RowID-1), 
                                                {
                                                    ...roleSettingFormData[data.RowID-1], 
                                                    IsCreate: !IsCreate
                                                },
                                                ...roleSettingFormData.slice(data.RowID), 
                                            ]
                                        ) 
                                    } 
                                />
                                <span className="slider round createcolor" style={{padding:"0 10px"}}>{IsCreate? 'on' : 'off'}</span>
                            </label>
                        </td>
                        <td>
                            <label className="switch"
                                style={ IsUpdate? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }
                            >
                                <input 
                                    type="checkbox" 
                                    checked={IsUpdate}
                                    onChange={() => 
                                        setRoleSettingFormData(
                                            [
                                                ...roleSettingFormData.slice(0, data.RowID-1), 
                                                { ...roleSettingFormData[data.RowID-1], IsUpdate: !IsUpdate },
                                                ...roleSettingFormData.slice(data.RowID), 
                                            ]
                                        ) 
                                    } 
                                />
                                <span className="slider round updatecolor" style={{padding:"0 10px"}}>{IsUpdate? 'on' : 'off'}</span>
                            </label>
                        </td>
                        <td>
                            <label className="switch"
                                style={ IsDelete? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }
                            >
                                <input 
                                    type="checkbox" 
                                    checked={IsDelete}
                                    onChange={() => 
                                        setRoleSettingFormData(
                                            [
                                                ...roleSettingFormData.slice(0, data.RowID-1), 
                                                { ...roleSettingFormData[data.RowID-1], IsDelete: !IsDelete },
                                                ...roleSettingFormData.slice(data.RowID), 
                                            ]
                                        ) 
                                    } 
                                />
                                <span className="slider round deletecolor" style={{padding:"0 10px"}}>{IsDelete? 'on' : 'off'}</span>
                            </label>
                        </td>
                    </tr>)
        }
    }
    const buttonInRolePermission = () => (
            <div className="text-right">
            <button
                className="btn btn-danger ml-2"
                onClick={() => setShowEditModal(defaultModal) }
            >
                <i className="fa fa-reply"></i> Cancel
            </button>
            <button
                className="btn btn-success ml-2"
                type="button"
                onClick={() => {
                    if (roleNameFormData.name === "") {
                        setAlert("role name is null! Plese fill", "warning");
                    } else {
                        setShowConfirm(true);
                    }
                }}              
            >
                {showEditModal.show === "Add" && <i className="fa fa-plus"> Add </i> }
                {showEditModal.show === "Edit" && <i className="fa fa-floppy-o"> Save</i> }
            </button>
        </div>
    )

    return (
        <Layout activeLinkTo="/roles" menuId="13">
            <div className="container-fluid" style={{ minHeight: 500 }}>
                <Alerts />
                <div className="card border-secondary">
                    <h5 className="card-header text-white bg-primary">Role</h5>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <label className="title control-label">Role Name</label>
                                <input
                                    type="search"
                                    className="form-control"
                                    value={roleSearchFormData.name}
                                    onKeyUp={ e => e.keyCode === 13 ? roleSearchUpdate(): null }
                                    onChange={e => setRoleSearchFormData({ name: e.target.value }) }
                                />
                            </div>
                        </div>
        
                        <div className="row mt-2 float-right">
                            <div className="col">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => roleSearchUpdate()}
                                >
                                    <i className="fa fa-search"></i> Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
                <div className="card border-secondary">
                    <h5 className="card-header text-white bg-primary">Data</h5>
                    <div className="card-body">
                        <div className="table-responsive" style={{padding:"10px 0"}}>
                            <button
                                hidden={!pagePermission.IsCreate}
                                type="button"
                                className="btn btn-success"
                                onClick={() => setShowEditModal({ show: "Add", pop: true, Id: "" }) }
                            >
                                <i className="fa fa-plus"></i> Add
                            </button>
                            <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                                <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                            </a>
                            <DataTable
                                noHeader={true}
                                pagination={true}
                                paginationPerPage={50}
                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                columns={roleColumns}
                                data={roleData}
                            />
                            <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                                <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Madal confirm add/edit */}
            <Modal
            show={showConfirm}
            onHide={() => {
                setShowConfirm(false);
            }}
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            {/*<Modal.Body><Alerts /></Modal.Body>*/}
            <Modal.Footer>
                <button
                    className="btn btn-danger ml-2"
                    onClick={() => {
                        setShowConfirm(false);
                    }}
                >
                <i className="fa fa-reply"></i> Cancel
                </button>
                <button
                    className="btn btn-success ml-2"
                    type="button"
                    onClick={() => {
                        saveAddEditRole(showEditModal.show);
                    }}
                >
                <i className="fa fa-floppy-o"></i> Save
                </button>
            </Modal.Footer>
            </Modal>
            {/* Madal confirm add/edit */}

            {/* Modal Delete address */}
            <Modal
                show={showDeleteModal.pop}
                onHide={() => {
                    setShowDeleteModel({ Id: "", pop: false });
                }}
                centered
                >
                <Modal.Header closeButton>
                    <div
                    style={{
                        width: 39,
                        height: 39,
                        borderWidth: 4,
                        borderStyle: "solid",
                        borderColor: "red",
                        borderRadius: "50%",
                        position: "relative"
                    }}
                    >
                    <span
                        style={{
                        width: 24,
                        height: 5,
                        position: "absolute",
                        backgroundColor: "red",
                        top: 13,
                        left: 3,
                        transform: "rotate(45deg)"
                        }}
                    ></span>
                    <span
                        style={{
                        width: 24,
                        height: 5,
                        position: "absolute",
                        backgroundColor: "red",
                        top: 13,
                        left: 3,
                        transform: "rotate(-45deg)"
                        }}
                    ></span>
                    </div>
                    <Modal.Title style={{ paddingLeft: 13 }}>Delete Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please make sure Once deleted, items cannot be returned.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                            setShowDeleteModel({ Id: "", pop: false });
                        }}
                        >
                        <i className="fa fa-reply"></i> Cancel
                    </button>
                    <button
                    className="btn btn-danger ml-2"
                    type="button"
                    onClick={async () => {
                        await axios
                        .put(
                            process.env.REACT_APP_API_URL +
                            "/api/role/delete/" +
                            showDeleteModal.Id,
                            {
                            createBy: userId
                            }
                        )
                        .then(res => {
                            setShowDeleteModel({ Id: "", pop: false });
                            setAlert(res.data.msg, "danger");
                            roleSearchUpdate();
                        });
                    }}
                    >
                    <i className="fa fa-trash-o"></i> Continue
                    </button>
                </Modal.Footer>
            </Modal>
            {/* Modal Delete address*/}

            {/* Modal Add/Edit Role */}
            <Modal
                show={showEditModal.pop}
                onHide={() => setShowEditModal(defaultModal) }
                centered
                size="lg"
            >
            <Modal.Header closeButton>
                {showEditModal.show === "Add" && <Modal.Title>Add Role</Modal.Title>}
                {showEditModal.show === "Edit" && <Modal.Title>Edit Role</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
                <div className="form-group col labelPadRight">
                    <Alerts />
                    {buttonInRolePermission()}
                    <div className="table-responsive innoheader">
                        <div className="row" style={{width: "600px", margin: "15px auto 20px"}}>
                            <div className="col-md-4" style={{alignSelf: "center"}}>
                                <label className="title control-label">Role Name<span style={{ color: "red" }}> * </span>: </label>
                            </div>
                            <div className="col-md-8">
                                <input 
                                    type="input"
                                    className="form-control"
                                    value={roleNameFormData.name}
                                    onChange={(e) => setRoleNameFormData({...roleNameFormData, name: e.target.value})}
                                />
                            </div>
                        </div>
                        <div className="row" style={{width: "600px", margin: "0px auto 20px"}}>
                            <div className="col-md-4" style={{alignSelf: "center"}}>
                                <label className="title control-label">Remark : </label>
                            </div>
                            <div className="col-md-8">
                                <input 
                                    type="input"
                                    className="form-control"
                                    value={roleNameFormData.desc}
                                    onChange={(e) => setRoleNameFormData({ ...roleNameFormData, desc: e.target.value})}
                                />
                            </div>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                <th scope="col" style={{paddingBottom:"28px"}}>Menu</th>
                                <th scope="col">
                                    <i className="fa fa-eye"> View</i>
                                    <br />
                                    <label className="switch" style={ selectAll.view? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }>
                                        <input 
                                            type="checkbox" 
                                            checked={selectAll.view} 
                                            onChange={(e) => {
                                                setSelectAll({ ...selectAll, view: !selectAll.view});
                                            }}
                                        />
                                        <span className="slider round" style={{padding:"0 10px"}}>All</span>
                                    </label>
                                </th>
                                <th scope="col">
                                    <i className="fa fa-plus" > Create</i>
                                    <br />
                                    <label className="switch" style={ selectAll.create? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }>
                                        <input 
                                            type="checkbox" 
                                            checked={selectAll.create} 
                                            onChange={(e) => {
                                                setSelectAll({ ...selectAll, create: !selectAll.create});
                                            }}
                                        />
                                        <span className="slider round createcolor" style={{padding:"0 10px"}}>All</span>
                                    </label>
                                </th>
                                <th scope="col">
                                    <i className="fa fa-pencil" > Update</i>
                                    <br />
                                    <label className="switch" style={ selectAll.update? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }>
                                        <input 
                                            type="checkbox" 
                                            checked={selectAll.update} 
                                            onChange={(e) => {
                                                setSelectAll({ ...selectAll, update: !selectAll.update});
                                            }}
                                        />
                                        <span className="slider round updatecolor" style={{padding:"0 10px"}}>All</span>
                                    </label>
                                </th>
                                <th scope="col">
                                    <i className="fa fa-remove" > Delete</i>
                                    <br />
                                    <label className="switch" style={ selectAll.delete? {color:"aliceblue", textAlign:"start"} :{color:"dimgray", textAlign:"end"} }>
                                        <input 
                                            type="checkbox" 
                                            checked={selectAll.delete} 
                                            onChange={(e) => {
                                                setSelectAll({ ...selectAll, delete: !selectAll.delete});
                                            }}
                                        />
                                        <span className="slider round deletecolor" style={{padding:"0 10px"}}>All</span>
                                    </label>
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                {roleSettingFormData.map( (e) => genBodyTableSetting(e))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {buttonInRolePermission()}
            </Modal.Footer>
            </Modal>
            {/* Modal Add/Edit Role */}
        </Layout>
    );
};

export default Role;